export const appNames = Object.freeze({
  //A -> B
  Pipedrive: 'pipedrive',
  WooCommerce: 'woocommerce',
  'Microsoft Bussiness Central': 'microsoftBC',
  'e-conomic': 'economic',
  HubSpot: 'hubspot',
  Stripe: 'stripe',
  Mailchimp: 'mailchimp',
  Magento: 'magento',
  Shopify: 'shopify',
  Inflow: 'inflow',
  Linkedin: 'linkedin',
  Katana: 'katana',
  Visma: 'visma',
  Facebook: 'facebook',
  Docusign: 'docusign',
  Fortnox: 'fortnox',
  Calendly: 'calendly',
  Syncro: 'syncro',
  Previsto: 'previsto',
  Clickup: 'clickup',
  Jotform: 'jotform',
  Typeform: 'typeform',
  //B -> A
  pipedrive: 'Pipedrive',
  woocommerce: 'WooCommerce',
  microsoftBC: 'Microsoft Bussiness Central',
  economic: 'e-conomic',
  hubspot: 'HubSpot',
  stripe: 'Stripe',
  mailchimp: 'Mailchimp',
  magento: 'Magento',
  shopify: 'Shopify',
  inflow: 'Inflow',
  linkedin: 'Linkedin',
  katana: 'Katana',
  visma: 'Visma',
  facebook: 'Facebook',
  docusign: 'Docusign',
  fortnox: 'Fortnox',
  calendly: 'Calendly',
  syncro: 'Syncro',
  previsto: 'Previsto',
  clickup: 'Clickup',
  jotform: 'Jotform',
  typeform: 'Typeform',
  amazon: 'Amazon',
})
